import classNames from "../../classNames";
import FormFactory from "../FormFactory";

function RelationForm({
  title,
  objects,
  object,
  onChangeForm,
  remove,
  schema,
  addForm,
  field,
}) {
  const deleteLabel =
    title === "Employment Background"
      ? "Delete Employer"
      : "Delete Character Reference";
  const addLabel =
    title === "Employment Background" ? "Add Employer" : "Add Reference";

  const uniqueObjects = Array.isArray(objects)
    ? objects.filter(
        (obj, index, self) => index === self.findIndex((o) => o.id === obj.id)
      )
    : [];

  return (
    <div className="bg-white d-flex flex-column overflow-hidden mt-4 w-100">
      <div className="mt-4">
        <b>{title}</b>
        <hr />
      </div>
      <div>
        <div className="row justify-content-md-start mt-1">
          {uniqueObjects.map((object, index) => (
            <div key={index} className="row justify-content-md-start mt-3">
              <FormFactory
                schema={schema}
                object={object}
                onChange={(value, field) =>
                  onChangeForm(value, field, object.id)
                }
              />
              {uniqueObjects.length > 1 && (
                <u
                  className="text-danger mt-2 cursor-pointer"
                  onClick={() => remove(object.id)}
                >
                  {deleteLabel}
                </u>
              )}
              <hr className="mt-3 border border-2"></hr>
            </div>
          ))}
        </div>
      </div>

      <div>
        <u
          className="cursor-pointer mt-2"
          style={{ color: `#D18237` }}
          onClick={addForm}
        >
          {addLabel}
        </u>
      </div>
    </div>
  );
}

export default RelationForm;
